import { Col, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { FadeInSlider } from '../../components';

const Wrapper = styled.div`
  margin-top: 48px;

  @media (max-width: 1024px) {
    margin-top: 130px;
  }
`;
const HeaderTitle = styled.div`
  font-family: CeraStencil;
  font-size: 72px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: -3.5px;
  text-indent: 50px;

  width: 420px;
`;
const Shoutout = (props) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col marg={isMobile ? '42px 0 0' : '98px 0 0'} noFlex centerAll center>
      <FadeInSlider
        headerTitle={
          <Row wid="420px">
            <Text
              stencil
              size="72px"
              bold
              lineHt="54px"
              style={{
                letterSpacing: -3.5,
                textIndent: 50
              }}
            >
              {t('website.loveTheGame')}
            </Text>
          </Row>
        }
        headerText={[
          t('website.sportsCareer'),
          t('website.monetizeYourBrand'),
          t('website.buildAnOngoing'),
          t('website.takeControl')
        ]}
        sliderElements={[
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.calculator'),
            content: t('website.signUpForFree')
          },
          {
            image: require('assets/images/tennis-phone-tilted.png'),
            title: t('website.connect!'),
            content: t('website.unlimitedAccess')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.stream!'),
            content: t('website.streamGamesFrom')
          }
        ]}
      />
    </Col>
  );
};

export default Shoutout;
